var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 6.125C1.875 13.0286 7.47144 18.625 14.375 18.625H16.25C17.2855 18.625 18.125 17.7855 18.125 16.75V15.607C18.125 15.1768 17.8322 14.8018 17.4149 14.6975L13.7289 13.776C13.363 13.6845 12.9778 13.8212 12.7515 14.123L11.943 15.201C11.7083 15.5139 11.3025 15.6522 10.9353 15.5177C8.17949 14.5082 5.9918 12.3205 4.9823 9.56472C4.84778 9.19749 4.98613 8.79165 5.299 8.557L6.37702 7.74849C6.67878 7.52217 6.81551 7.13704 6.72403 6.77111L5.80253 3.08512C5.69819 2.66778 5.32321 2.375 4.89302 2.375H3.75C2.71447 2.375 1.875 3.21447 1.875 4.25V6.125Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bf86004df1384a3a5ed93aea263d670d.svg";
export { ForwardRef as ReactComponent };